// extracted by mini-css-extract-plugin
export default {"status":"Settings_status__ms4O8","button":"Settings_button__41xgi","delete":"Settings_delete__Yn9EL","privacy":"Settings_privacy__RWS8u"};